import { render } from "./jqzysjDetail.vue?vue&type=template&id=45c4be22&scoped=true&ts=true"
import script from "./jqzysjDetail.vue?vue&type=script&lang=ts"
export * from "./jqzysjDetail.vue?vue&type=script&lang=ts"

import "./jqzysjDetail.vue?vue&type=style&index=0&id=45c4be22&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c4be22"]])

export default __exports__